import {getModelFactory} from "../model-factory/ModelFactory";
import eventBus from "./EventBus";
import RouteModel from "../model-factory/basic/route/RouteModel";
import DataModel from "../model-factory/basic/data/DataModel";
import {getManager} from "../manager/Manager";


export const dispatchRedirectTo = (path: string, immediately:boolean = false, replace:boolean = false, callback?:() => void ) =>
{
    getManager().ui.isImmediateRedirect = immediately;
    if(callback)
    {
        const handleCallback = () => {
            eventBus.remove("site.redirect-complete", handleCallback);
            setTimeout(() => {
                callback();
            },1)
        }
        eventBus.on("site.redirect-complete", handleCallback);
    }
    const callRedirect = () => {
        eventBus.dispatch('site.redirect-to', {path: path, replace:replace});
    }
    if(immediately){
        callRedirect();
    } else {
        setTimeout(() => callRedirect(),)
    }
}

export const dispatchInternetConnectionUpdate = (disconnected: boolean = false, isRetry: boolean = false) =>
{
    eventBus.dispatch('site.internet-connection-update', {disconnected: disconnected, isRetry: isRetry});
}

export const dispatchNavigationRouteChangeStart = () =>
{
    eventBus.dispatch('site.navigation-route-change-start');
}

export const dispatchNavigationRouteUpdate = () =>
{
    eventBus.dispatch('site.navigation-route-update');
}

export const dispatchRedirectComplete = () =>
{
    eventBus.dispatch('site.redirect-complete');
}

export const dispatchOnUserLogInOut = () =>
{
    eventBus.dispatch('site.on-user-log-in-out');
}

export const dispatchSiteLoad = () =>
{
    eventBus.dispatch('site.on-site-load');
}

export const dispatchLocationUpdate = () =>
{
    eventBus.dispatch('site.user-location-update');
}

export const dispatchResetRouteBaseURLs = () =>
{
    eventBus.dispatch('site.reset-route-base-urls');
}

export const dispatchRefreshPage = () =>
{
    eventBus.dispatch('site.refresh-page');
}

export const dispatchRefreshUI = () =>
{
    eventBus.dispatch('site.refresh-ui');
}

export const dispatchUpdateBaseState = () =>
{
    eventBus.dispatch('site.update-base-state');
}

export const dispatchShowHideDebugView = (visible:boolean) =>
{
    eventBus.dispatch('site.show-hide-debug-view', {visible: visible});
}

export const dispatchBaseClick = (htmlElement:HTMLElement|null) =>
{
    eventBus.dispatch('site.base-click', {htmlElement: htmlElement});
}

export const dispatchRedirectHome = (immediately:boolean = false) =>
{
    const path = getModelFactory().browseRoute.getDefaultModel().choices.homepage?.getHref() ?? "/";
    dispatchRedirectTo(path, immediately);
}

export const dispatchRouteModelUpdate = (routeModel:RouteModel) =>
{
    eventBus.dispatch('site.route-model-update', {routeModel: routeModel});
}

export const dispatchFetchRequestStateChange = () =>
{
    eventBus.dispatch('site.fetch-request-state-change');
}

export const dispatchDataModelUpdate = (dataModel:DataModel) =>
{
    eventBus.dispatch('site.data-model-update', {dataModel: dataModel});
}

export const dispatchAllComponentsRendered = () =>
{
    eventBus.dispatch('site.all-components-rendered');
}

export const dispatchAnimationBlocksEnded = () =>
{
    eventBus.dispatch('site.animation-blocks-ended');
}